import { createSlice } from '@reduxjs/toolkit'

export const ProjectStatusOrder = createSlice({
  name: 'order_status',
  initialState: {
    value: [0,1,2,3,4,5]
  },
  reducers: {
    updateOrder: (state, action) => {
      state.value = action.payload
    },
  },
})

export const { updateOrder } = ProjectStatusOrder.actions

export default ProjectStatusOrder.reducer